import _ from 'lodash';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { BiTrackApi } from '../../apis/bi-track-api';
import type { BiTrackEventType } from '../../types';
import type { BiTrackRepository } from '../../services/bi-track-repository';

@injectable()
export class BiTrackRepositoryImpl implements BiTrackRepository {
    constructor(
        @inject(BiTrackApi) private _biTrackApi: BiTrackApi
    ) { }

    private _stringify(data: Record<string, unknown>) {
        return JSON.stringify(data);
    }

    biTrack(eventType: string, data: BiTrackEventType) {
        const { sourceType, otherParam, eventDetailStr } = data;
        let detailStr = eventDetailStr;
        if (!_.isString(eventDetailStr)) {
            detailStr = eventDetailStr ? this._stringify(eventDetailStr) : undefined;
        }

        return this._biTrackApi.biTrack({
            event_type: eventType,
            source_type: sourceType,
            other_param: otherParam,
            event_detail_str: detailStr as string,
            module_type: 'EUREKA',
        });
    }
}
